<meta charset="utf-8">

<h4>
    Agenda
    <img id="imgFavorite" alt="seleccionado" src="/assets/imgs/ic_estrella_selected.png" width="16" height="16" style="margin-left: 5px;"
       (click)="selectFavoriteCompeticion()"/>
</h4>

<div id="loading" *ngIf="loading">
    <img src="assets/imgs/spinner.gif" width="100%"/>
</div>

<div>
	<div id="divPartidos">
		<table id="tablePartidos" class="table table-striped" *ngIf="partidos && partidos.length > 0">
		  <thead>
		    <tr class="small">
              <th class="nopadding text-center">Comp.</th>
		      <th class="nopadding text-center">Fecha</th>
		      <th class="nopadding text-center">Local</th>
              <th class="nopadding text-center">Visitante</th>
              <th class="nopadding text-center">Pista</th>
		    </tr>
		  </thead>
		  <tbody class="small">
		    <tr *ngFor="let partido of partidos let index = index">
              <td class="nopadding align-middle">{{partido.competicionName}}</td>
		      <td class="nopadding align-middle">{{partido.fecha | date:'dd/MM'}} {{partido.hora}}</td>
		      <td class="nopadding align-middle"
		         [style.font-weight]="partido.equipoLocal.includes('ALUCHE') ? 'bold' : 'normal'">{{partido.equipoLocal}}</td>
		      <td class="nopadding align-middle"
		         [style.font-weight]="partido.equipoVisitante.includes('ALUCHE') ? 'bold' : 'normal'">{{partido.equipoVisitante}}</td>
		      <td class="nopadding align-middle">
		          <a href="#" (click)="openMaps(partido.pista)">
		              <img alt="location" src="/assets/imgs/google-maps-new.png" width="16" height="16" class="center"/>
		          </a>
		      </td>
		    </tr>
		  </tbody>
		</table>
	</div>
</div>